export default `query Products(
      $search: String
      $currentPage: Int
      $filter: ProductAttributeFilterInput
      $pageSize: Int
      $sort: ProductAttributeSortInput,
      $id: Int
    ) {
    category (id: $id) {
      name
      display_mode
      breadcrumbs{
        category_id
        category_url_path
        category_url_key
        category_level
        category_id
        category_name
      }
      custom_canonical_link
      href_lang_links{href, hreflang}
      meta_description
      meta_title
      meta_keywords
      meta_robots
      head_content_page
    }
    products(
      search: $search
      currentPage: $currentPage
      filter: $filter
      pageSize: $pageSize
      sort: $sort ) {
      items {
        id
        sku
        name
        size
        stock_status
        url_suffix
        url_key
        color
        color_label
        color_image
        model_sku
        sibling_products {
          url_key
          url_suffix
          color
          color_label
          color_image
        }
        categories{
          breadcrumbs{
            category_name
            category_url_path
          }          
        }
        image{
          label
          url
        }
        media_gallery{
          position
          disabled
          label
          url
          ...on ProductVideo {
            position
            video_content {
              media_type
              video_provider
              video_url
              video_title
              video_description
              video_metadata
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            id
            label
            attribute_code
            attribute_id
            values {
              value_index
              label
              default_label
              store_label
            }
          }
          variants {
            product {
              id
              sku
              stock_status
              name
              quantity
            }
            attributes {
              label
              code
              value_index
            }
          }
        }
      }
      total_count
      aggregations {
        attribute_code
        count
        label
        options {
          count
          label
          value
        }
      }
      aggregationsStore {
        attribute_code
        count
        label
        options {
          count
          label
          value
        }
      }
      sort_fields{
        default
        options{
          label,
          value
        }
      }
    }
  }`
